import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { UserRepository } from "../repositories/UserRepository";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  notifyShowErrorMessage,
  notifyShowSuccessMessage,
} from "../../store/AlertSlice";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";

export default function ActivateAccount() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });
  const [data, setData] = useState({
    code: searchParams.get("code"),
    password: "",
    confirmPassword: "",
  });
  const dispatch = useDispatch();

  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const toggleShowPassword = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleAccountActivation = () => {
    setLoading(true);
    UserRepository.activateAccount(data)
      .then((res) => {
        setLoading(false);
        dispatch(notifyShowSuccessMessage("Профилот е успешно потврден."));
        navigate("/login");
      })
      .catch((err) => {
        setLoading(false);
        console.error("Error activating account:", err);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(err)));
      });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4} />
      <Grid item xs={12} md={4} style={{ textAlign: "center", margin: 5 }}>
        <Typography variant="h5">Потврда на профил</Typography>
        <div style={{ marginTop: "30px" }}>
          <TextField
            size="medium"
            fullWidth
            placeholder="Лозинка"
            autoComplete="off"
            type={showPassword.password ? "text" : "password"}
            inputProps={{ spellCheck: "false" }}
            onChange={(e) => handleChange("password", e.target.value)}
            value={data.password}
            className="login-textfield"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleShowPassword("password");
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                      if (e.key === "Enter") {
                        toggleShowPassword("password");
                      }
                    }}
                  >
                    {showPassword.password ? (
                      <FaRegEye className="login-show-hide-password-icon" />
                    ) : (
                      <FaRegEyeSlash className="login-show-hide-password-icon" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            size="medium"
            fullWidth
            placeholder="Потврди лозинка"
            autoComplete="off"
            disabled={data.password === ""}
            type={showPassword.confirmPassword ? "text" : "password"}
            inputProps={{ spellCheck: "false" }}
            onChange={(e) => handleChange("confirmPassword", e.target.value)}
            value={data.confirmPassword}
            className="login-textfield"
            style={{ marginTop: 20 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleShowPassword("confirmPassword");
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                      if (e.key === "Enter") {
                        toggleShowPassword("confirmPassword");
                      }
                    }}
                  >
                    {showPassword.confirmPassword ? (
                      <FaRegEye className="login-show-hide-password-icon" />
                    ) : (
                      <FaRegEyeSlash className="login-show-hide-password-icon" />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={() => handleAccountActivation()}
            style={{ marginTop: 20 }}
            disabled={data.password === "" && data.confirmPassword === ""}
          >
            {!loading ? (
              <Typography className="login-button-text">Потврди</Typography>
            ) : (
              <CircularProgress size={20} id="circular-progress" />
            )}
          </Button>
        </div>
      </Grid>
      <Grid item xs={12} md={4} />
    </Grid>
  );
}
